module.exports = __webpack_public_path__ + "img/INTERIOR-S-CROSS-3.775771a7.jpg";